import { FC, useState, MutableRefObject, useEffect } from "react";
import Image from "next/image";
import locationImg from "@/img/location.svg";
import GoogleMapsComponent from "../googleMaps/GoogleMapsComponent";
import { Transition } from "@headlessui/react";
import PlacesAutocomplete from "../googleMaps/AutocompleteInput";
import type { GoogleGeocodeLocation, Marker } from "utils/googleMapsUtils";
interface MobileZipcodeProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  openRef?: MutableRefObject<boolean>;
  zipcode: string;
  setZipcode: (newZipcode: string) => void;
  zipcodeRef?: MutableRefObject<string>;
  isLoaded: boolean;
  apiKey: string;
  setLocation: (location: string) => void;
  geocodeLocation: GoogleGeocodeLocation;
  setGeocodeLocation: (location: GoogleGeocodeLocation) => void;
  handleSubmit: (e, modalZipcode?: string) => void;
}

const DarkenScreen = () => {
  return (
    <div className="absolute inset-0 z-20 h-screen bg-black bg-opacity-20" />
  );
};

const MobileZipcode: FC<MobileZipcodeProps> = ({
  open,
  setOpen,
  isLoaded,
  setZipcode,
  zipcodeRef,
  setLocation,
  geocodeLocation,
  setGeocodeLocation,
  openRef,
  handleSubmit,
  zipcode,
}) => {
  const [modalZipcode, setModalZipcode] = useState(zipcode);

  const handleSave = (event) => {
    event.preventDefault();
    if (/^\d{5}$/.test(modalZipcode)) {
      if (zipcodeRef) zipcodeRef.current = modalZipcode;
      setZipcode(modalZipcode);
      setOpen(false);
    }
  };

  if (!open) return null;
  return (
    <>
      <DarkenScreen />
      <div className="fixed inset-x-0 bottom-0 z-40 rounded-t-3xl bg-white p-6 text-black shadow-2xl">
        <div className="mx-auto mb-4 h-1 w-12 rounded-full bg-gray-300" />
        <div className="flex items-center justify-between">
          <h2 className="text-2xl font-bold text-youdleDarkBlue">Change location</h2>
          <button type="button" onClick={() => setOpen(false)} className="rounded-full p-2 text-2xl leading-none text-gray-701" aria-label="Close location dialog">×</button>
        </div>
        <p className="mt-2 text-sm leading-6 text-gray-701">Enter your ZIP code to see groceries near you.</p>
        <form className="mt-6" onSubmit={handleSave}>
          <label className="sr-only" htmlFor="mobile-location-zipcode">ZIP code</label>
          <input
            autoFocus
            id="mobile-location-zipcode"
            className="h-12 w-full rounded-xl border border-gray-300 px-4 text-base text-youdleDarkBlue outline-none focus:border-blue focus:ring-2 focus:ring-blue/20"
            value={modalZipcode || ""}
            onChange={(event) => setModalZipcode(event.target.value.replace(/\\D/g, "").slice(0, 5))}
            inputMode="numeric"
            pattern="[0-9]{5}"
            maxLength={5}
            placeholder="ZIP code"
            required
          />
          <div className="mt-5 flex gap-3">
            <button type="button" onClick={() => setOpen(false)} className="flex-1 rounded-xl px-4 py-3 text-sm font-semibold text-youdleDarkBlue hover:bg-gray-100">Cancel</button>
            <button type="submit" className="flex-1 rounded-xl bg-yellow px-4 py-3 text-sm font-bold text-youdleDarkBlue hover:bg-yellow-400">Save</button>
          </div>
        </form>
      </div>
    </>
  );
  // return (
  //   <>
  //     {open && <DarkenScreen />}
  //     <Transition
  //       show={open}
  //       appear={true}
  //       enter="transform transition ease-in-out duration-250"
  //       enterFrom="translate-y-full"
  //       enterTo="translate-y-0"
  //       className="border-gray-700 fixed inset-x-0 bottom-0 z-40 min-h-fit rounded-3xl rounded-b-none bg-white bg-opacity-100 pb-8 text-black"
  //     >
  //       <div>
  //         <div
  //           className="flex w-full justify-center pt-4"
  //           onClick={(e) => handleClick(e)}
  //           onTouchEnd={(e) => handleClick(e)}
  //         >
  //           <svg
  //             className=" "
  //             width="48"
  //             height="4"
  //             viewBox="0 0 48 4"
  //             fill="none"
  //             xmlns="http://www.w3.org/2000/svg"
  //           >
  //             <rect width="48" height="4" rx="2" fill="#D9D9D9" />
  //           </svg>
  //         </div>
  //         <div className="flex w-full justify-between px-6 pt-4 font-[Montserrat] text-3xl font-bold">
  //           <div className="">Edit Location</div>
  //           <div className="self-center" onClick={(e) => handleClick(e)}>
  //             <svg
  //               width="24"
  //               height="24"
  //               viewBox="0 0 24 24"
  //               fill="none"
  //               xmlns="http://www.w3.org/2000/svg"
  //             >
  //               <path
  //                 d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
  //                 stroke="#757575"
  //                 stroke-width="2"
  //                 stroke-linecap="round"
  //                 stroke-linejoin="round"
  //               />
  //             </svg>
  //           </div>
  //         </div>
  //         <form className="px-6 py-4">
  //           <div className="items-center" id="location-input-modal">
  //             <i className="absolute p-3 pl-4">
  //               <Image src={locationImg} alt="" />
  //             </i>

  //             <input
  //               className="hidden"
  //               value={modalZipcode || ""}
  //               type="text"
  //               name="zipcode"
  //               placeholder="Zip Code"
  //               pattern="/(^\d{5}$)|(^\d{5}-\d{4}$)/"
  //               minLength={5}
  //               maxLength={5}
  //               onInvalid={(e) =>
  //                 e.currentTarget.setCustomValidity(
  //                   "Your zip code must be exactly 5 characters long.",
  //                 )
  //               }
  //               required
  //               onChange={(e) => setModalZipcode(e.target.value)}
  //             />
  //             {isLoaded && (
  //               <PlacesAutocomplete
  //                 mapRef={mapRef}
  //                 curMarker={curMarker}
  //                 setModalZipcode={setModalZipcode}
  //                 setLocation={setLocation}
  //                 modalZipcode={modalZipcode}
  //                 geocodeLocation={geocodeLocation}
  //               />
  //             )}
  //           </div>
  //           <div className="">
  //             {isLoaded ? (
  //               <GoogleMapsComponent
  //                 modalZipcode={modalZipcode}
  //                 setZipcode={setZipcode}
  //                 setModalZipcode={setModalZipcode}
  //                 mapHeight="350px"
  //                 setMapRef={setMapRef}
  //                 setCurMarker={setCurMarker}
  //                 curMarker={curMarker}
  //                 setLocation={setLocation}
  //                 openRef={openRef}
  //                 setGeocodeLocation={setGeocodeLocation}
  //               />
  //             ) : (
  //               <div className="h-[350px]" />
  //             )}
  //           </div>
  //           <div className="py-1">
  //             <button
  //               onClick={(e) => {
  //                 handleClick(e);
  //               }}
  //               className="h-12 w-full rounded-3xl bg-red py-3.5 text-center !text-white"
  //               type="submit"
  //             >
  //               Submit
  //             </button>
  //           </div>
  //         </form>
  //       </div>
  //     </Transition>
  //   </>
  // );
};

export default MobileZipcode;
